/*
 *
 *Company constants
 *
 */

export const CHILDREN_HOSPIS = '3367924295000';
